// Koalafi customer support contact info, centralized so the phone number is defined in one place.
export const SUPPORT_PHONE_NUMBER = '(844) 937-8275';
// tel: href derived from the display number so the two never drift apart.
export const SUPPORT_PHONE_TEL = `tel:${SUPPORT_PHONE_NUMBER.replace(/\D/g, '')}`;
